import React from 'react'

import PropTypes from 'prop-types'

import numberMask from '@galo-monitor/forms/masks/number.mask'
import TextField from '@galo-monitor/web-components/TextField'

const InputNumber = props => (
  <TextField
    setMask={ numberMask }
    { ...props }
    type="tel"
  />
)

InputNumber.propTypes = {
  /** Defines mask characters's limit  */
  maxLength: PropTypes.number
}

InputNumber.defaultProps = {
  maxLength: 10
}

export default InputNumber
